const autoNgTemplateLoaderTemplate1 = require('./add-food.template.html');
const autoNgTemplateLoaderTemplate2 = require('./add-food.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.addFood', [])
        .config(addFoodConfig);

    addFoodConfig.$inject = ['$routeProvider'];

    function addFoodConfig($routeProvider) {
        $routeProvider
            .when('/angular/add-food/:type', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'AddFoodController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Add Food', icon: NAVIGATION_ICON.GROCERY }
                    ]
                }
            })
            .when('/angular/edit-food/:type/:id', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate2,
                controller: 'AddFoodController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Edit Food', icon: NAVIGATION_ICON.GROCERY }
                    ]
                }
            })
    }
})();
